/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class CountDown extends ThemeComponent {
    @Ref timerElement!: HTMLElement;
    private interval?: NodeJS.Timeout;

    init(): void {
        this.interval = setInterval(this.getCountdown.bind(this), 1000);
    }

    private getCountdown(): void {
        const data = JSON.parse(this.timerElement.getAttribute('data-countdown')!);
        const location = data.location;
        const daylightSaving = data.daylight_saving;
        let timezone = 'GMT';

        if (location === 'AU') {
            // AEST + 10
            timezone = 'AEST';
        } else if (location === 'EU') {
            // CET + 2
            timezone = 'CET';
        } else if (location === 'US') {
            // EST - 4
            timezone = 'EST';
        } else {
            // bst + 1
            // GMT + 0
            timezone = daylightSaving === 'true' ? 'BST' : 'GMT';
        }

        const remaining = this.getTimeRemaining(data.sale_end, timezone);
        const html = this.buildHtml(remaining, timezone);

        this.timerElement.innerHTML = html;
    }

    private buildHtml(remaining: CountdownData, timezone: string): string {
        return `
        <div class="flex f-dir-column text-align-center">
            <span class="countdown__unit above-tablet">DAYS</span>
            <span class="countdown__unit tablet-only">DAYS</span>
            <span class="countdown__time">${remaining.days}</span>
        </div>

        <div class="flex f-dir-column text-align-center">
            <span class="countdown__colon"> : </span>
        </div>

        <div class="flex f-dir-column text-align-center">
            <span class="countdown__unit above-tablet">HOURS</span>
            <span class="countdown__unit tablet-only">HRS</span>
            <span class="countdown__time">${remaining.hours}</span>
        </div>

        <div class="flex f-dir-column text-align-center">
            <span class="countdown__colon"> : </span>
        </div>

        <div class="flex f-dir-column text-align-center">
            <span class="countdown__unit above-tablet">MINUTES</span>
            <span class="countdown__unit tablet-only">MIN</span>
            <span class="countdown__time">${remaining.minutes}</span>
        </div>

        <div class="flex f-dir-column text-align-center">
            <span class="countdown__colon"> : </span>
        </div>

        <div class="flex f-dir-column text-align-center">
            <span class="countdown__unit above-tablet">SECONDS</span>
            <span class="countdown__unit tablet-only">SEC</span>
            <span class="countdown__time">${remaining.seconds}</span>
        </div>
        <div class="countdown__timezone flex f-dir-column text-align-center f-space-end">
            <span class="countdown__unit">${timezone}</span>
        </div>
        `;
    }

    private getTimeRemaining(endtime: string, timezone: string): CountdownData {
        const targetDate = new Date(endtime);
        const currentTime = new Date();

        const totalSeconds = Math.floor((targetDate.getTime() - currentTime.getTime()) / 1000);

        if (totalSeconds < 0) {
            return {
                hours: 0,
                minutes: 0,
                seconds: 0,
                days: 0
            };
        }

        const days = Math.floor(totalSeconds / (3600 * 24));
        const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = Math.floor(totalSeconds % 60);

        return {
            hours,
            minutes,
            seconds,
            days
        };
    }
}

interface CountdownData {
    hours: number;
    minutes: number;
    seconds: number;
    days: number;
}
